import includes from 'lodash/includes';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';

import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export async function savePreference(app, dataToSave) {
  const { user = {}, data } = dataToSave;
  let preferenceData = {
    doc_type: DocType.PREFERENCE,
    pref_type: util.toStringText(data.pref_type),
    type_id: util.toStringText(data.type_id),
    setting: util.toStringText(data.setting),
    setting_type: util.toStringText(data.setting_type),
    value: data.value,
    licensed: util.toBoolean(data.licensed),
    system_defined: util.toBoolean(data.system_defined)
  };

  if (data._deleted) {
    return await common.deleteDoc(app, { id: data.id, docType: DocType.PREFERENCE });
  } else {
    const savedDoc = await common.saveDoc(app, {
      source: data,
      doc: preferenceData,
      user,
    });
    return savedDoc;
  }
}

export function fetchPreferenceById(app, params) {
  const { id } = params;
  const docType = DocType.PREFERENCE;
  return common.getDoc(app, { id, docType });
}

export function fetchPreferencesWithFilter(app, data) {
  const { filter } = data;
  const service = common.getAccountService(app, DocType.PREFERENCE);

  const query = {
    selector: {
      $or: filter
    },
    // profile: app.get('user_info'),
    limit: 1000
  };

  return service.find({ query });
}

export function fetchPreferenceDataByTypeIds(app, data) {
  const { typeIds } = data;
  if (typeIds.length) {
    const service = common.getAccountService(app, DocType.PREFERENCE);
    const query = { selector: { _id: { $in: typeIds } }, fields: ['_id', 'name', 'doc_type'] };
    // const query = { selector: { _id: { $in: typeIds } }, profile: app.get('user_info'), fields: ['_id', 'name', 'doc_type'] };
    return service.find({ query });
  } else {
    return { docs: [] };
  }
}

export async function getDocPreferences(app, params) {
  const { preferences } = params;

  const preferenceSettingsWithList = {
    cash_rounding: [],
    currency: [],
    custom_form: [],
    custom_tab: [],
    delivery_type: [],
    hotkey_template: [],
    integration: [],
    price_level: [],
    print_template: [],
    reason_code: [],
    shortcut_group: [],
    shortcut: [],
  };
  const docTypes = Object.keys(preferenceSettingsWithList);

  preferences.forEach(preference => {
    const { list: docType } = preference;
    const prefTypes = ['account', 'location', 'subsidiary'];

    if (includes(docTypes, docType)) {
      prefTypes.forEach(prefType => {
        if (!isEqual(preference[prefType], 'inherit') && !isEmpty(preference[prefType])) {
          preferenceSettingsWithList[docType].push(preference[prefType]);
        }
      });
    }
  });

  const fields = ['id', 'name'];
  const data = [];

  for (let i = 0; i < docTypes.length; i++) {
    const docType = docTypes[i];
    const ids = preferenceSettingsWithList[docType];

    if (!isEmpty(ids)) {
      for (let j = 0; j < ids.length; j++) {
        const id = ids[j];
        const existingItem = data.find(item => item.id === id);

        if (existingItem) {
          data.push(existingItem);
          continue;
        }

        const query = {
          dropdown_type: `${docType}/dropdown`,
          fields: docType === 'hotkey_template' ? [...fields, 'reference_id'] : fields,
          [`${docType}_id`]: id
        };

        try {
          const result = await common.getDropdownList(app, { query });
          data.push(...result);
        } catch (err) {
          console.log('Unable to find preference dropdown');
        }
      }
    }
  }

  return data;
}

export async function getPreferenceSetting(app, params) {
  const { locId, subId, tid: accId, setting } = params;

  const typeIds = [];
  if (locId) typeIds.push(locId);
  if (subId) typeIds.push(subId);
  if (accId) typeIds.push(accId);

  const dataParams = {
    filters: {
      type_ids: typeIds,
      settings: [setting],
    },
    list_type: 'preference',
  };

  const preferencesRes = await common.getDocs(app, dataParams);
  const preferences = preferencesRes.data || [];

  let locPreference;
  let subPreference;
  let accPreference;

  for (const preference of preferences) {
    const { pref_type } = preference;

    switch (pref_type) {
      case 'location':
        locPreference = preference;
        break;

      case 'subsidiary':
        subPreference = preference;
        break;

      case 'account':
        accPreference = preference;
        break;

      default:
        break;
    }
  }

  const preference = locPreference || subPreference || accPreference || {};
  return preference;
}